import { createBrowserRouter, RouteObject } from 'react-router-dom';
import React, { Component, Suspense } from 'react';
import { FullPageSpinner } from 'src/common/FullPageSpinner';

import AppContainer from 'src/components/common/AppContainer/AppContainer';

import { ROUTES } from './routes';
import Landing from 'src/components/pages/LandingPage';

// Lazy-load heavy pages — keeps them out of the main bundle
const ControlHomePage = React.lazy(() =>
  import('src/components/pages/ControlHomePage').then((m) => ({ default: m.ControlHomePage }))
);
const SummaryPage = React.lazy(() =>
  import('src/components/pages/SummaryPage').then((m) => ({ default: m.SummaryPage }))
);
const HistoricalExecutionsPage = React.lazy(() =>
  import('src/components/pages/HistoricalExecutionsPage').then((m) => ({
    default: m.HistoricalExecutionsPage,
  }))
);
const ReportsPage = React.lazy(() =>
  import('src/components/pages/ReportsPage').then((m) => ({ default: m.ReportsPage }))
);
const ProcurementDefectsGridPage = React.lazy(
  () => import('src/components/pages/ProcurementDefectsGridPage')
);

export class ChunkErrorBoundary extends Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false };
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('Chunk load error:', error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ textAlign: 'center', padding: '100px' }}>
          <p>Something went wrong loading this page.</p>
          <button onClick={() => window.location.reload()}>Refresh</button>
        </div>
      );
    }
    return this.props.children;
  }
}

const LazyRoute = ({ children }: { children: React.ReactNode }) => (
  <ChunkErrorBoundary>
    <Suspense fallback={<FullPageSpinner />}>{children}</Suspense>
  </ChunkErrorBoundary>
);

export const routeConfig = [
  {
    path: ROUTES.HOME,
    element: <AppContainer />,
    children: [
      {
        index: true,
        element: <Landing />,
      },
      {
        path: ROUTES.CONTROL.BASE,
        element: (
          <LazyRoute>
            <ControlHomePage />
          </LazyRoute>
        ),
      },
      {
        path: ROUTES.CONTROL.SUMMARY,
        element: (
          <LazyRoute>
            <SummaryPage />
          </LazyRoute>
        ),
      },
      {
        path: ROUTES.CONTROL.HISTORICAL,
        element: (
          <LazyRoute>
            <HistoricalExecutionsPage />
          </LazyRoute>
        ),
      },
      {
        path: ROUTES.PROCUREMENT.BASE,
        element: (
          <LazyRoute>
            <ProcurementDefectsGridPage />
          </LazyRoute>
        ),
      },
      {
        path: ROUTES.REPORTS.DETAIL,
        element: (
          <LazyRoute>
            <ReportsPage />
          </LazyRoute>
        ),
      },
    ],
  },
];

export const router = createBrowserRouter(routeConfig as RouteObject[]);
